import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(private confirmationService: ConfirmationService,
    private translateService:TranslateService
  ) {}

  showConfirmationDialog(
    header: string,
    message: string,
    acceptLabel = this.translateService.instant('Yes'),
    rejectLabel = this.translateService.instant('No')
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-exclamation-triangle',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  updateVersionConfirmationDialog(
    header: string,
    message: string,
    acceptLabel = this.translateService.instant('Yes'),
    rejectLabel = this.translateService.instant('No')
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-cloud-download',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  showDeleteDialog(
    header: string,
    message: string,
    acceptLabel = this.translateService.instant('Delete'),
    rejectLabel = this.translateService.instant('Cancel')
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-exclamation-circle',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
